import styled from 'styled-components'

export const TagListStyle = styled.div`
display: flex;
flex-wrap: wrap;

column-gap: 5px;
row-gap: 7px;
`